import React, { useState, useMemo, useContext } from 'react'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'

import { connect } from 'react-redux'
import { DatePicker, Button, InputNumber, Upload, Icon, message } from 'antd'
import { Label } from 'core/screen-util'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import {
  getInstalledCapacitiveClaimed,
  deleteInstalledCapacitiveClaimed,
  saveInstalledCapacitiveClaimed,
  getAuthorization,
  getCredentials,
} from 'api/pgads'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { ErrorContext, SpinContext, JcTmpErrorContext } from 'context'

import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  UtilityUnitSelection,
} from 'core'

const title = 'Installed Capacity'

const InstalledCapClaimed = ({
  utilityNameMap,
  unitNameMap,
  targetInfo,
  envConfig,
  actionPermits,
}) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const { setError } = useContext(ErrorContext)

  const { setSpinning } = useContext(SpinContext)

  const { setTmpError } = useContext(JcTmpErrorContext)

  const headerWithFormatter = useMemo(
    _ =>
      InstalledCapacityClaimedHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '250px 100px 250px 100px 100px 150px 150px',
        gap: '5px',
      }}
    >
      <Label>Utility / Unit : </Label>

      <UtilityUnitSelection
        utility={insertData.utility}
        unit={insertData.unitId}
        onUnitChange={value => {
          // setUtilityUnit(value)
          setInsertData({
            ...insertData,
            utility: value[0],
            unitId: value[1],
            unit: value[1].substr(3),
          })
        }}
        casStyle={{ gridColumnEnd: 'span 3' }}
      />

      <Label>Effective Date : </Label>
      <DatePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={insertData.effectivedateMom}
        onChange={date => {
          setInsertData({
            ...insertData,
            effectivedateMom: date,
            effectivedate: date.format('YYYY-MM-DD'),
          })
        }}
      />
      <div />
      <Label>Summer Installed Capacity : </Label>
      <InputNumber
        defaultValue={0}
        onChange={value => setInsertData({ ...insertData, instCapSum: value })}
      />
      <Label>Winter Installed Capacity : </Label>
      <InputNumber
        defaultValue={0}
        onChange={value => setInsertData({ ...insertData, instCapWin: value })}
      />
      <Button type="primary" onClick={() => onAdd(true)}>
        Add
      </Button>
      <Button type="primary" onClick={() => onAdd(false)}>
        Add & Hide
      </Button>
      <Button type="danger" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  const importPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CHANGE_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const fileProps = {
    name: 'file',
    action: `${targetInfo.baseUrl}/pjm-admin/import-installed-cap-claimed-manual`,
    method: 'POST',
    data: {},
    headers: getAuthorization(targetInfo),
    ...getCredentials(targetInfo),
  }

  const withCriteria = (s, p, su) => su.map(u => u.unitId)
  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    return (
      <Upload
        {...fileProps}
        beforeUpload={_ => setSpinning(true)}
        onChange={data => {
          setSpinning(false)
          if (
            data.file.response &&
            data.file.response.restfulStatus &&
            data.file.response.restfulStatus === 'FAILURE'
          ) {
            // setShowMessages(true)
            // setMessages([data.file.response])
            setError(data.file.response)
          } else if (data.file.response && data.file.response.length === 0) {
            //  if (data.file.response) {
            message.success('File imported successfully')
            onRetrieve()
            // }
          } else if (data.file.response && data.file.response.length > 0) {
            setTmpError(data.file.response)
            //  if (data.file.response) {
            // message.success('File imported successfully')
            // }
          }
        }}
        multiple={false}
        showUploadList={false}
      >
        <Button disabled={!importPermission} type="primary">
          <Icon type="upload" /> Import
        </Button>
      </Upload>
    )
  }

  return (
    <CommonScreen
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      isAdminScreen
      withUnitSelection
      withCriteria={withCriteria}
      title={title}
      header={headerWithFormatter}
      saveTask={saveInstalledCapacitiveClaimed}
      retrieveTask={getInstalledCapacitiveClaimed}
      deleteTask={deleteInstalledCapacitiveClaimed}
      altBy={d => d.unitId}
      autoRetrieve={false}
      sortOptions={InstalledCapacityClaimedHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
      defaultInsertData={{ instCapSum: 0, instCapWin: 0 }}
    />
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(InstalledCapClaimed)

// eslint-disable-next-line no-unused-vars
const InstalledCapacityClaimedHeaders = [
  utilityHeader,
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'instCapSum',
    display: 'Summer Installed Capacity ',
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'instCapWin',
    display: 'Winter Installed Capacity',
    width: 200,
  }),
  modifierCol,
  modifiedDateCol,
]
